@file:OptIn(InternalResourceApi::class)

package devicehub.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/devicehub.composeapp.generated.resources/"

@delegate:ResourceContentHash(340_355_541)
internal val Res.string.add_device_button_title: StringResource by lazy {
      StringResource("string:add_device_button_title", "add_device_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 47),
      ))
    }

@delegate:ResourceContentHash(1_339_968_798)
internal val Res.string.add_device_tag_label: StringResource by lazy {
      StringResource("string:add_device_tag_label", "add_device_tag_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58, 56),
      ))
    }

@delegate:ResourceContentHash(649_524_231)
internal val Res.string.add_device_title: StringResource by lazy {
      StringResource("string:add_device_title", "add_device_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115, 44),
      ))
    }

@delegate:ResourceContentHash(1_612_078_616)
internal val Res.string.application_version_label: StringResource by lazy {
      StringResource("string:application_version_label", "application_version_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160, 45),
      ))
    }

@delegate:ResourceContentHash(1_107_774_719)
internal val Res.string.brightness_control_title: StringResource by lazy {
      StringResource("string:brightness_control_title", "brightness_control_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206, 60),
      ))
    }

@delegate:ResourceContentHash(-1_320_945_082)
internal val Res.string.cancel_button_title: StringResource by lazy {
      StringResource("string:cancel_button_title", "cancel_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 267, 35),
      ))
    }

@delegate:ResourceContentHash(111_733_814)
internal val Res.string.close_hint: StringResource by lazy {
      StringResource("string:close_hint", "close_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303, 26),
      ))
    }

@delegate:ResourceContentHash(1_976_855_628)
internal val Res.string.confirm_button_title: StringResource by lazy {
      StringResource("string:confirm_button_title", "confirm_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330, 40),
      ))
    }

@delegate:ResourceContentHash(1_661_544_318)
internal val Res.string.control_screen_title: StringResource by lazy {
      StringResource("string:control_screen_title", "control_screen_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 371, 56),
      ))
    }

@delegate:ResourceContentHash(2_056_113_711)
internal val Res.string.device_action_confirm_title: StringResource by lazy {
      StringResource("string:device_action_confirm_title", "device_action_confirm_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 428, 75),
      ))
    }

@delegate:ResourceContentHash(-969_519_154)
internal val Res.string.device_card_last_active_title: StringResource by lazy {
      StringResource("string:device_card_last_active_title", "device_card_last_active_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 504, 53),
      ))
    }

@delegate:ResourceContentHash(3_001_443)
internal val Res.string.device_card_software_version_title: StringResource by lazy {
      StringResource("string:device_card_software_version_title", "device_card_software_version_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 558, 46),
      ))
    }

@delegate:ResourceContentHash(254_167_665)
internal val Res.string.device_card_tag_title: StringResource by lazy {
      StringResource("string:device_card_tag_title", "device_card_tag_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 605, 37),
      ))
    }

@delegate:ResourceContentHash(558_512_523)
internal val Res.string.device_control_unavailable_label: StringResource by lazy {
      StringResource("string:device_control_unavailable_label", "device_control_unavailable_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 643, 104),
      ))
    }

@delegate:ResourceContentHash(1_969_875_609)
internal val Res.string.device_delete_confirm_dialog: StringResource by lazy {
      StringResource("string:device_delete_confirm_dialog", "device_delete_confirm_dialog", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 748, 140),
      ))
    }

@delegate:ResourceContentHash(-139_824_752)
internal val Res.string.device_details_connection_string_label: StringResource by lazy {
      StringResource("string:device_details_connection_string_label", "device_details_connection_string_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 889, 66),
      ))
    }

@delegate:ResourceContentHash(-1_744_800_486)
internal val Res.string.device_details_general_section_label: StringResource by lazy {
      StringResource("string:device_details_general_section_label", "device_details_general_section_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 956, 56),
      ))
    }

@delegate:ResourceContentHash(-1_440_970_630)
internal val Res.string.device_details_id_label: StringResource by lazy {
      StringResource("string:device_details_id_label", "device_details_id_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1013, 43),
      ))
    }

@delegate:ResourceContentHash(1_189_593_917)
internal val Res.string.device_details_last_activity_label: StringResource by lazy {
      StringResource("string:device_details_last_activity_label", "device_details_last_activity_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1057, 62),
      ))
    }

@delegate:ResourceContentHash(-4_828_847)
internal val Res.string.device_details_linking_password: StringResource by lazy {
      StringResource("string:device_details_linking_password", "device_details_linking_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1120, 59),
      ))
    }

@delegate:ResourceContentHash(471_493_044)
internal val Res.string.device_details_local_ip_address_label: StringResource by lazy {
      StringResource("string:device_details_local_ip_address_label", "device_details_local_ip_address_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1180, 69),
      ))
    }

@delegate:ResourceContentHash(591_381_202)
internal val Res.string.device_details_mac_address_label: StringResource by lazy {
      StringResource("string:device_details_mac_address_label", "device_details_mac_address_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1250, 56),
      ))
    }

@delegate:ResourceContentHash(-372_209_047)
internal val Res.string.device_details_management_section_label: StringResource by lazy {
      StringResource("string:device_details_management_section_label", "device_details_management_section_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1307, 63),
      ))
    }

@delegate:ResourceContentHash(2_004_035_896)
internal val Res.string.device_details_model_label: StringResource by lazy {
      StringResource("string:device_details_model_label", "device_details_model_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1371, 42),
      ))
    }

@delegate:ResourceContentHash(439_582_583)
internal val Res.string.device_details_network_section_label: StringResource by lazy {
      StringResource("string:device_details_network_section_label", "device_details_network_section_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1414, 56),
      ))
    }

@delegate:ResourceContentHash(2_605_182)
internal val Res.string.device_details_not_available_label: StringResource by lazy {
      StringResource("string:device_details_not_available_label", "device_details_not_available_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1471, 46),
      ))
    }

@delegate:ResourceContentHash(1_447_295_166)
internal val Res.string.device_details_screen_title: StringResource by lazy {
      StringResource("string:device_details_screen_title", "device_details_screen_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1518, 55),
      ))
    }

@delegate:ResourceContentHash(1_600_267_649)
internal val Res.string.device_details_security_section_label: StringResource by lazy {
      StringResource("string:device_details_security_section_label", "device_details_security_section_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1574, 57),
      ))
    }

@delegate:ResourceContentHash(-622_710_984)
internal val Res.string.device_details_serial_number_label: StringResource by lazy {
      StringResource("string:device_details_serial_number_label", "device_details_serial_number_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1632, 62),
      ))
    }

@delegate:ResourceContentHash(1_298_613_739)
internal val Res.string.device_details_software_section_label: StringResource by lazy {
      StringResource("string:device_details_software_section_label", "device_details_software_section_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1695, 57),
      ))
    }

@delegate:ResourceContentHash(1_617_505_265)
internal val Res.string.device_details_status_active_label: StringResource by lazy {
      StringResource("string:device_details_status_active_label", "device_details_status_active_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1753, 50),
      ))
    }

@delegate:ResourceContentHash(549_457_120)
internal val Res.string.device_details_status_inactive_label: StringResource by lazy {
      StringResource("string:device_details_status_inactive_label", "device_details_status_inactive_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1804, 56),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.device_details_status_label: StringResource by lazy {
      StringResource("string:device_details_status_label", "device_details_status_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1861, 43),
      ))
    }

@delegate:ResourceContentHash(2_632_537)
internal val Res.string.device_details_tag_label: StringResource by lazy {
      StringResource("string:device_details_tag_label", "device_details_tag_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1905, 36),
      ))
    }

@delegate:ResourceContentHash(-2_018_929_787)
internal val Res.string.device_details_type_label: StringResource by lazy {
      StringResource("string:device_details_type_label", "device_details_type_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1942, 41),
      ))
    }

@delegate:ResourceContentHash(-1_062_967_896)
internal val Res.string.device_details_unlink_device_label: StringResource by lazy {
      StringResource("string:device_details_unlink_device_label", "device_details_unlink_device_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1984, 62),
      ))
    }

@delegate:ResourceContentHash(1_278_635_603)
internal val Res.string.device_general_settings_title: StringResource by lazy {
      StringResource("string:device_general_settings_title", "device_general_settings_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2047, 61),
      ))
    }

@delegate:ResourceContentHash(340_355_541)
internal val Res.string.device_list_add_button_title: StringResource by lazy {
      StringResource("string:device_list_add_button_title", "device_list_add_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2109, 52),
      ))
    }

@delegate:ResourceContentHash(1_794_819_111)
internal val Res.string.device_list_admin_toggle_label: StringResource by lazy {
      StringResource("string:device_list_admin_toggle_label", "device_list_admin_toggle_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2162, 46),
      ))
    }

@delegate:ResourceContentHash(1_667_804_653)
internal val Res.string.device_list_download_button_title: StringResource by lazy {
      StringResource("string:device_list_download_button_title", "device_list_download_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2209, 73),
      ))
    }

@delegate:ResourceContentHash(-439_741_565)
internal val Res.string.device_list_register_button_title: StringResource by lazy {
      StringResource("string:device_list_register_button_title", "device_list_register_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2283, 69),
      ))
    }

@delegate:ResourceContentHash(-1_440_149_479)
internal val Res.string.device_list_title: StringResource by lazy {
      StringResource("string:device_list_title", "device_list_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2353, 37),
      ))
    }

@delegate:ResourceContentHash(-1_610_356_956)
internal val Res.string.device_list_user_toggle_label: StringResource by lazy {
      StringResource("string:device_list_user_toggle_label", "device_list_user_toggle_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2391, 45),
      ))
    }

@delegate:ResourceContentHash(1_982_517_832)
internal val Res.string.device_management_details_tab_label: StringResource by lazy {
      StringResource("string:device_management_details_tab_label", "device_management_details_tab_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2437, 55),
      ))
    }

@delegate:ResourceContentHash(-177_335_339)
internal val Res.string.device_management_live_view_tab_label: StringResource by lazy {
      StringResource("string:device_management_live_view_tab_label", "device_management_live_view_tab_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2493, 57),
      ))
    }

@delegate:ResourceContentHash(-670_865_204)
internal val Res.string.device_management_messages_tab_label: StringResource by lazy {
      StringResource("string:device_management_messages_tab_label", "device_management_messages_tab_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2551, 56),
      ))
    }

@delegate:ResourceContentHash(-1_346_131_604)
internal val Res.string.device_management_output_tab_label: StringResource by lazy {
      StringResource("string:device_management_output_tab_label", "device_management_output_tab_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2608, 54),
      ))
    }

@delegate:ResourceContentHash(2_636_903)
internal val Res.string.device_management_roi_tab_label: StringResource by lazy {
      StringResource("string:device_management_roi_tab_label", "device_management_roi_tab_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2663, 43),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
internal val Res.string.device_management_settings_tab_label: StringResource by lazy {
      StringResource("string:device_management_settings_tab_label", "device_management_settings_tab_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2707, 56),
      ))
    }

@delegate:ResourceContentHash(-1_959_108_374)
internal val Res.string.device_menu_item_delete_label: StringResource by lazy {
      StringResource("string:device_menu_item_delete_label", "device_menu_item_delete_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2764, 45),
      ))
    }

@delegate:ResourceContentHash(377_512_238)
internal val Res.string.device_menu_item_open_label: StringResource by lazy {
      StringResource("string:device_menu_item_open_label", "device_menu_item_open_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2810, 43),
      ))
    }

@delegate:ResourceContentHash(1_087_767_378)
internal val Res.string.device_menu_item_unlink_label: StringResource by lazy {
      StringResource("string:device_menu_item_unlink_label", "device_menu_item_unlink_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2854, 45),
      ))
    }

@delegate:ResourceContentHash(-1_788_953_045)
internal val Res.string.device_unlink_confirm_dialog: StringResource by lazy {
      StringResource("string:device_unlink_confirm_dialog", "device_unlink_confirm_dialog", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2900, 128),
      ))
    }

@delegate:ResourceContentHash(1_293_979_442)
internal val Res.string.device_update_type: StringResource by lazy {
      StringResource("string:device_update_type", "device_update_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3029, 42),
      ))
    }

@delegate:ResourceContentHash(252_081_622)
internal val Res.string.error_data_invalid_credentials: StringResource by lazy {
      StringResource("string:error_data_invalid_credentials", "error_data_invalid_credentials", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3072, 66),
      ))
    }

@delegate:ResourceContentHash(-1_546_303_326)
internal val Res.string.error_data_local_disk_full: StringResource by lazy {
      StringResource("string:error_data_local_disk_full", "error_data_local_disk_full", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3139, 58),
      ))
    }

@delegate:ResourceContentHash(81_916_394)
internal val Res.string.error_data_local_formatting: StringResource by lazy {
      StringResource("string:error_data_local_formatting", "error_data_local_formatting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3198, 59),
      ))
    }

@delegate:ResourceContentHash(-1_936_388_434)
internal val Res.string.error_data_local_invalid_argument: StringResource by lazy {
      StringResource("string:error_data_local_invalid_argument", "error_data_local_invalid_argument", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3258, 65),
      ))
    }

@delegate:ResourceContentHash(-1_438_763_300)
internal val Res.string.error_data_local_invalid_state: StringResource by lazy {
      StringResource("string:error_data_local_invalid_state", "error_data_local_invalid_state", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3324, 58),
      ))
    }

@delegate:ResourceContentHash(137_058_803)
internal val Res.string.error_data_local_not_found: StringResource by lazy {
      StringResource("string:error_data_local_not_found", "error_data_local_not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3383, 46),
      ))
    }

@delegate:ResourceContentHash(-605_871_445)
internal val Res.string.error_data_local_serialization: StringResource by lazy {
      StringResource("string:error_data_local_serialization", "error_data_local_serialization", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3430, 66),
      ))
    }

@delegate:ResourceContentHash(-1_027_201_492)
internal val Res.string.error_data_no_internet: StringResource by lazy {
      StringResource("string:error_data_no_internet", "error_data_no_internet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3497, 46),
      ))
    }

@delegate:ResourceContentHash(137_058_803)
internal val Res.string.error_data_not_found: StringResource by lazy {
      StringResource("string:error_data_not_found", "error_data_not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3544, 40),
      ))
    }

@delegate:ResourceContentHash(364_861_448)
internal val Res.string.error_data_rate_limit_exceeded: StringResource by lazy {
      StringResource("string:error_data_rate_limit_exceeded", "error_data_rate_limit_exceeded", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3585, 66),
      ))
    }

@delegate:ResourceContentHash(-172_448_166)
internal val Res.string.error_data_request_timeout: StringResource by lazy {
      StringResource("string:error_data_request_timeout", "error_data_request_timeout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3652, 54),
      ))
    }

@delegate:ResourceContentHash(-605_871_445)
internal val Res.string.error_data_serialization: StringResource by lazy {
      StringResource("string:error_data_serialization", "error_data_serialization", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3707, 60),
      ))
    }

@delegate:ResourceContentHash(-53_426_167)
internal val Res.string.error_data_service_unavailable: StringResource by lazy {
      StringResource("string:error_data_service_unavailable", "error_data_service_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3768, 66),
      ))
    }

@delegate:ResourceContentHash(984_233_258)
internal val Res.string.error_data_storage_full: StringResource by lazy {
      StringResource("string:error_data_storage_full", "error_data_storage_full", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3835, 51),
      ))
    }

@delegate:ResourceContentHash(722_207_528)
internal val Res.string.error_data_storage_not_reachable: StringResource by lazy {
      StringResource("string:error_data_storage_not_reachable", "error_data_storage_not_reachable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3887, 72),
      ))
    }

@delegate:ResourceContentHash(-417_615_806)
internal val Res.string.error_data_too_many_requests: StringResource by lazy {
      StringResource("string:error_data_too_many_requests", "error_data_too_many_requests", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3960, 60),
      ))
    }

@delegate:ResourceContentHash(-1_250_970_865)
internal val Res.string.error_data_unknown: StringResource by lazy {
      StringResource("string:error_data_unknown", "error_data_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4021, 46),
      ))
    }

@delegate:ResourceContentHash(1_785_763_966)
internal val Res.string.error_data_user_already_exists: StringResource by lazy {
      StringResource("string:error_data_user_already_exists", "error_data_user_already_exists", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4068, 66),
      ))
    }

@delegate:ResourceContentHash(1_630_141_044)
internal val Res.string.error_data_user_locked: StringResource by lazy {
      StringResource("string:error_data_user_locked", "error_data_user_locked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4135, 46),
      ))
    }

@delegate:ResourceContentHash(-94_253_926)
internal val Res.string.error_general_title: StringResource by lazy {
      StringResource("string:error_general_title", "error_general_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4182, 35),
      ))
    }

@delegate:ResourceContentHash(863_001_072)
internal val Res.string.focus_control_title: StringResource by lazy {
      StringResource("string:focus_control_title", "focus_control_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4218, 35),
      ))
    }

@delegate:ResourceContentHash(1_823_667_186)
internal val Res.string.frame_rotation_enum_name_0: StringResource by lazy {
      StringResource("string:frame_rotation_enum_name_0", "frame_rotation_enum_name_0", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4254, 46),
      ))
    }

@delegate:ResourceContentHash(-253_238_184)
internal val Res.string.frame_rotation_enum_name_180: StringResource by lazy {
      StringResource("string:frame_rotation_enum_name_180", "frame_rotation_enum_name_180", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4301, 52),
      ))
    }

@delegate:ResourceContentHash(2_029_820_420)
internal val Res.string.frame_rotation_enum_name_90: StringResource by lazy {
      StringResource("string:frame_rotation_enum_name_90", "frame_rotation_enum_name_90", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4448, 51),
      ))
    }

@delegate:ResourceContentHash(1_459_878_894)
internal val Res.string.frame_rotation_enum_name_90_counter_clockwise: StringResource by lazy {
      StringResource("string:frame_rotation_enum_name_90_counter_clockwise", "frame_rotation_enum_name_90_counter_clockwise", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4354, 93),
      ))
    }

@delegate:ResourceContentHash(2_556_903)
internal val Res.string.id_title: StringResource by lazy {
      StringResource("string:id_title", "id_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4500, 20),
      ))
    }

@delegate:ResourceContentHash(-1_904_180_807)
internal val Res.string.live_view_connect_label: StringResource by lazy {
      StringResource("string:live_view_connect_label", "live_view_connect_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4521, 43),
      ))
    }

@delegate:ResourceContentHash(-14_152_886)
internal val Res.string.live_view_disable_label: StringResource by lazy {
      StringResource("string:live_view_disable_label", "live_view_disable_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4565, 55),
      ))
    }

@delegate:ResourceContentHash(-324_837_708)
internal val Res.string.live_view_disconnect_label: StringResource by lazy {
      StringResource("string:live_view_disconnect_label", "live_view_disconnect_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4621, 50),
      ))
    }

@delegate:ResourceContentHash(-1_495_378_611)
internal val Res.string.live_view_enable_label: StringResource by lazy {
      StringResource("string:live_view_enable_label", "live_view_enable_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4672, 54),
      ))
    }

@delegate:ResourceContentHash(-177_335_339)
internal val Res.string.live_view_screen_title: StringResource by lazy {
      StringResource("string:live_view_screen_title", "live_view_screen_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4727, 42),
      ))
    }

@delegate:ResourceContentHash(2_004_028_332)
internal val Res.string.live_view_web_rtc_mode_label: StringResource by lazy {
      StringResource("string:live_view_web_rtc_mode_label", "live_view_web_rtc_mode_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4770, 44),
      ))
    }

@delegate:ResourceContentHash(2_010_710_353)
internal val Res.string.live_view_web_rtc_mode_title: StringResource by lazy {
      StringResource("string:live_view_web_rtc_mode_title", "live_view_web_rtc_mode_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4815, 68),
      ))
    }

@delegate:ResourceContentHash(-1_066_531_385)
internal val Res.string.load_config_button_title: StringResource by lazy {
      StringResource("string:load_config_button_title", "load_config_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4884, 68),
      ))
    }

@delegate:ResourceContentHash(691_855_911)
internal val Res.string.login_button_title: StringResource by lazy {
      StringResource("string:login_button_title", "login_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4953, 34),
      ))
    }

@delegate:ResourceContentHash(-1_713_180_008)
internal val Res.string.login_field_placeholder_email: StringResource by lazy {
      StringResource("string:login_field_placeholder_email", "login_field_placeholder_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4988, 45),
      ))
    }

@delegate:ResourceContentHash(-1_252_028_226)
internal val Res.string.login_field_placeholder_password: StringResource by lazy {
      StringResource("string:login_field_placeholder_password", "login_field_placeholder_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5034, 52),
      ))
    }

@delegate:ResourceContentHash(-594_574_083)
internal val Res.string.login_forgot_password_button_title: StringResource by lazy {
      StringResource("string:login_forgot_password_button_title", "login_forgot_password_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5087, 66),
      ))
    }

@delegate:ResourceContentHash(-1_245_803_346)
internal val Res.string.login_register_button_title: StringResource by lazy {
      StringResource("string:login_register_button_title", "login_register_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5154, 79),
      ))
    }

@delegate:ResourceContentHash(691_852_147)
internal val Res.string.logout_label: StringResource by lazy {
      StringResource("string:logout_label", "logout_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5234, 28),
      ))
    }

@delegate:ResourceContentHash(-843_098_702)
internal val Res.string.message_details_anpr_title: StringResource by lazy {
      StringResource("string:message_details_anpr_title", "message_details_anpr_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5263, 42),
      ))
    }

@delegate:ResourceContentHash(1_767_598_498)
internal val Res.string.message_details_confidence_score: StringResource by lazy {
      StringResource("string:message_details_confidence_score", "message_details_confidence_score", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5306, 64),
      ))
    }

@delegate:ResourceContentHash(-975_431_745)
internal val Res.string.message_details_cpu_temperature: StringResource by lazy {
      StringResource("string:message_details_cpu_temperature", "message_details_cpu_temperature", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5371, 67),
      ))
    }

@delegate:ResourceContentHash(-15_116_350)
internal val Res.string.message_details_cpu_usage: StringResource by lazy {
      StringResource("string:message_details_cpu_usage", "message_details_cpu_usage", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5439, 53),
      ))
    }

@delegate:ResourceContentHash(-2_018_929_787)
internal val Res.string.message_details_device_title: StringResource by lazy {
      StringResource("string:message_details_device_title", "message_details_device_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5493, 44),
      ))
    }

@delegate:ResourceContentHash(352_240_592)
internal val Res.string.message_details_enclosure_humidity: StringResource by lazy {
      StringResource("string:message_details_enclosure_humidity", "message_details_enclosure_humidity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5538, 74),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("add_device_button_title", Res.string.add_device_button_title)
  map.put("add_device_tag_label", Res.string.add_device_tag_label)
  map.put("add_device_title", Res.string.add_device_title)
  map.put("application_version_label", Res.string.application_version_label)
  map.put("brightness_control_title", Res.string.brightness_control_title)
  map.put("cancel_button_title", Res.string.cancel_button_title)
  map.put("close_hint", Res.string.close_hint)
  map.put("confirm_button_title", Res.string.confirm_button_title)
  map.put("control_screen_title", Res.string.control_screen_title)
  map.put("device_action_confirm_title", Res.string.device_action_confirm_title)
  map.put("device_card_last_active_title", Res.string.device_card_last_active_title)
  map.put("device_card_software_version_title", Res.string.device_card_software_version_title)
  map.put("device_card_tag_title", Res.string.device_card_tag_title)
  map.put("device_control_unavailable_label", Res.string.device_control_unavailable_label)
  map.put("device_delete_confirm_dialog", Res.string.device_delete_confirm_dialog)
  map.put("device_details_connection_string_label", Res.string.device_details_connection_string_label)
  map.put("device_details_general_section_label", Res.string.device_details_general_section_label)
  map.put("device_details_id_label", Res.string.device_details_id_label)
  map.put("device_details_last_activity_label", Res.string.device_details_last_activity_label)
  map.put("device_details_linking_password", Res.string.device_details_linking_password)
  map.put("device_details_local_ip_address_label", Res.string.device_details_local_ip_address_label)
  map.put("device_details_mac_address_label", Res.string.device_details_mac_address_label)
  map.put("device_details_management_section_label", Res.string.device_details_management_section_label)
  map.put("device_details_model_label", Res.string.device_details_model_label)
  map.put("device_details_network_section_label", Res.string.device_details_network_section_label)
  map.put("device_details_not_available_label", Res.string.device_details_not_available_label)
  map.put("device_details_screen_title", Res.string.device_details_screen_title)
  map.put("device_details_security_section_label", Res.string.device_details_security_section_label)
  map.put("device_details_serial_number_label", Res.string.device_details_serial_number_label)
  map.put("device_details_software_section_label", Res.string.device_details_software_section_label)
  map.put("device_details_status_active_label", Res.string.device_details_status_active_label)
  map.put("device_details_status_inactive_label", Res.string.device_details_status_inactive_label)
  map.put("device_details_status_label", Res.string.device_details_status_label)
  map.put("device_details_tag_label", Res.string.device_details_tag_label)
  map.put("device_details_type_label", Res.string.device_details_type_label)
  map.put("device_details_unlink_device_label", Res.string.device_details_unlink_device_label)
  map.put("device_general_settings_title", Res.string.device_general_settings_title)
  map.put("device_list_add_button_title", Res.string.device_list_add_button_title)
  map.put("device_list_admin_toggle_label", Res.string.device_list_admin_toggle_label)
  map.put("device_list_download_button_title", Res.string.device_list_download_button_title)
  map.put("device_list_register_button_title", Res.string.device_list_register_button_title)
  map.put("device_list_title", Res.string.device_list_title)
  map.put("device_list_user_toggle_label", Res.string.device_list_user_toggle_label)
  map.put("device_management_details_tab_label", Res.string.device_management_details_tab_label)
  map.put("device_management_live_view_tab_label", Res.string.device_management_live_view_tab_label)
  map.put("device_management_messages_tab_label", Res.string.device_management_messages_tab_label)
  map.put("device_management_output_tab_label", Res.string.device_management_output_tab_label)
  map.put("device_management_roi_tab_label", Res.string.device_management_roi_tab_label)
  map.put("device_management_settings_tab_label", Res.string.device_management_settings_tab_label)
  map.put("device_menu_item_delete_label", Res.string.device_menu_item_delete_label)
  map.put("device_menu_item_open_label", Res.string.device_menu_item_open_label)
  map.put("device_menu_item_unlink_label", Res.string.device_menu_item_unlink_label)
  map.put("device_unlink_confirm_dialog", Res.string.device_unlink_confirm_dialog)
  map.put("device_update_type", Res.string.device_update_type)
  map.put("error_data_invalid_credentials", Res.string.error_data_invalid_credentials)
  map.put("error_data_local_disk_full", Res.string.error_data_local_disk_full)
  map.put("error_data_local_formatting", Res.string.error_data_local_formatting)
  map.put("error_data_local_invalid_argument", Res.string.error_data_local_invalid_argument)
  map.put("error_data_local_invalid_state", Res.string.error_data_local_invalid_state)
  map.put("error_data_local_not_found", Res.string.error_data_local_not_found)
  map.put("error_data_local_serialization", Res.string.error_data_local_serialization)
  map.put("error_data_no_internet", Res.string.error_data_no_internet)
  map.put("error_data_not_found", Res.string.error_data_not_found)
  map.put("error_data_rate_limit_exceeded", Res.string.error_data_rate_limit_exceeded)
  map.put("error_data_request_timeout", Res.string.error_data_request_timeout)
  map.put("error_data_serialization", Res.string.error_data_serialization)
  map.put("error_data_service_unavailable", Res.string.error_data_service_unavailable)
  map.put("error_data_storage_full", Res.string.error_data_storage_full)
  map.put("error_data_storage_not_reachable", Res.string.error_data_storage_not_reachable)
  map.put("error_data_too_many_requests", Res.string.error_data_too_many_requests)
  map.put("error_data_unknown", Res.string.error_data_unknown)
  map.put("error_data_user_already_exists", Res.string.error_data_user_already_exists)
  map.put("error_data_user_locked", Res.string.error_data_user_locked)
  map.put("error_general_title", Res.string.error_general_title)
  map.put("focus_control_title", Res.string.focus_control_title)
  map.put("frame_rotation_enum_name_0", Res.string.frame_rotation_enum_name_0)
  map.put("frame_rotation_enum_name_180", Res.string.frame_rotation_enum_name_180)
  map.put("frame_rotation_enum_name_90", Res.string.frame_rotation_enum_name_90)
  map.put("frame_rotation_enum_name_90_counter_clockwise", Res.string.frame_rotation_enum_name_90_counter_clockwise)
  map.put("id_title", Res.string.id_title)
  map.put("live_view_connect_label", Res.string.live_view_connect_label)
  map.put("live_view_disable_label", Res.string.live_view_disable_label)
  map.put("live_view_disconnect_label", Res.string.live_view_disconnect_label)
  map.put("live_view_enable_label", Res.string.live_view_enable_label)
  map.put("live_view_screen_title", Res.string.live_view_screen_title)
  map.put("live_view_web_rtc_mode_label", Res.string.live_view_web_rtc_mode_label)
  map.put("live_view_web_rtc_mode_title", Res.string.live_view_web_rtc_mode_title)
  map.put("load_config_button_title", Res.string.load_config_button_title)
  map.put("login_button_title", Res.string.login_button_title)
  map.put("login_field_placeholder_email", Res.string.login_field_placeholder_email)
  map.put("login_field_placeholder_password", Res.string.login_field_placeholder_password)
  map.put("login_forgot_password_button_title", Res.string.login_forgot_password_button_title)
  map.put("login_register_button_title", Res.string.login_register_button_title)
  map.put("logout_label", Res.string.logout_label)
  map.put("message_details_anpr_title", Res.string.message_details_anpr_title)
  map.put("message_details_confidence_score", Res.string.message_details_confidence_score)
  map.put("message_details_cpu_temperature", Res.string.message_details_cpu_temperature)
  map.put("message_details_cpu_usage", Res.string.message_details_cpu_usage)
  map.put("message_details_device_title", Res.string.message_details_device_title)
  map.put("message_details_enclosure_humidity", Res.string.message_details_enclosure_humidity)
}
